<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-site-notification-form',

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        setFile($event) {
            this.model.icon_id = $event.id
            this.model.icon = $event
        }
    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.TITLE') }}
            </label>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name">
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                Aktív?
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.is_active">
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                Link
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.link">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
              Ikon
            </label>
            <div class="col-md-6">
                <img v-if="model.icon && model.icon.display_url" :src="model.icon.display_url" style="width: 100%; max-width: 360px;">
                <label class="btn btn-sm btn-primary">
                  <mv-uploader ref="uploader" @upload-done="setFile($event)" accept="image/*" type="media"></mv-uploader>
                  <icon name="file"></icon>
                </label>
            </div>
        </div>
    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/SiteNotificationForm.vue